module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/layouts/scroll-top/scroll-top.component.html
// module id = ./src/app/theme/layouts/scroll-top/scroll-top.component.html
// module chunks = main